import apiClient from "../../utils/apiClient";

const API_URL = "/admin/services";

// Get all services
export async function getAllServices() {
    try {
        const response = await apiClient.get(`${API_URL}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching services:", error);
        throw error;
    }
}

// Get single service by ID
export async function getServiceById(serviceId) {
    try {
        const response = await apiClient.get(`${API_URL}/${serviceId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching service:", error);
        throw error;
    }
}

// Create new service
export async function createService(serviceData) {
    try {
        const response = await apiClient.post(`${API_URL}`, serviceData);
        return response.data;
    } catch (error) {
        console.error("Error creating service:", error);
        throw error;
    }
}

// Update service
export async function updateService(serviceId, serviceData) {
    try {
        const response = await apiClient.put(`${API_URL}/${serviceId}`, serviceData);
        return response.data;
    } catch (error) {
        console.error("Error updating service:", error);
        throw error;
    }
}

// Delete service
export async function deleteService(serviceId) {
    try {
        const response = await apiClient.delete(`${API_URL}/${serviceId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting service:", error);
        throw error;
    }
}

// Toggle service status
export async function toggleServiceStatus(serviceId) {
    try {
        const response = await apiClient.patch(`${API_URL}/${serviceId}/status`);
        return response.data;
    } catch (error) {
        console.error("Error toggling service status:", error);
        throw error;
    }
}
